import React, {useState} from "react";
import { v } from "../../env/env_variable";

import './Login.css'

import { db, auth } from '../../utils/db/Authorize'

import {
  createUserWithEmailAndPassword,
  signInWithEmailAndPassword,
  onAuthStateChanged,
  signOut,
  updateProfile
} from "firebase/auth";
import firebase from "firebase/compat/app";

import { getFirestore, collection, addDoc } from "firebase/firestore";
import { v4 as uuidv4 } from "uuid";

import { useStateValue } from "../../utils/provider/StateProvider";
import { useNavigate } from "react-router-dom";

function Login() {
    
    const [{user}, dispatch] = useStateValue();
    const navigate = useNavigate()


    // toggle state:
    const [new_account, isAccount] = useState(false)

    
    const [name, setName] = useState("")
    const [email, setEmail] = useState("")
    const [password, setPassword] = useState("")


    // functions:
    const createAccount = async(e) => {
        // new account:

        if(name.length === 0){
            alert("Name cannot be empty")
        }else {
            const { user } = await createUserWithEmailAndPassword(auth, email, password)
      
            await updateProfile(user, {
                displayName: name
            });
            
            const data = {
                name: name,
                uid: uuidv4()
            }

            // Adding profile records to database:
            const proColl = collection(db, email, "account", "profile")
            const doc = addDoc(proColl, data)

            // Creating user profile on general db:
            data['email'] = email
            const genCol = addDoc(collection(db, "users"), data)
            console.log("adding records", user, db)

            if(user){
                dispatch({
                type: 'ADD_USER',
                user: user
                })
                console.log("new User created !", user)
            }
            isAccount(false)
            // navigate("/")
        }

        
    }


    const onLogin = async(e) => {
        // Login to existing account
        // e.preventDefault();

        try {
          const user = await signInWithEmailAndPassword(
            auth,
            email,
            password
          );
          console.log(user.user);
    
          dispatch({
            type: 'ADD_USER',
            user: user.user
          })
        } catch (error) {
          console.log(error.message);
        }

    }

    return (
        <div className="login_container">
            <div className="login_main_body">
                <div className="login_header">
                    {v.PAGE_TITLE}
                </div>

                <div className="login_header_hint">
                    welcome to <span>{v.PAGE_TITLE}</span>, create account to proceed !
                </div>

                <div className="login_body_inputs">

                    { new_account && 
                        <div className="login_body_input_row ">
                            <label className="login_input_label">Name</label>
                            <input className="login_input"  value={name} onChange={e => setName(e.target.value)} placeholder="User Name" />
                        </div>
                    }

                    <div className="login_body_input_row">
                        <label className="login_input_label">Email</label>
                        <input className="login_input" value={email} onChange={e => setEmail(e.target.value)} placeholder="Email" />
                    </div>
                    
                    <div className="login_body_input_row ">
                        <label className="login_input_label">Password</label>
                        <input className="login_input" type="password" value={password} onChange={e => setPassword(e.target.value)} placeholder="Password" />
                    </div>
                    
                    
                    <div className="login_body_input_row ">
                        {new_account ?
                            <button className="login_body_button" onClick={() => createAccount()}>Create Account</button>
                            :
                            <button className="login_body_button" onClick={() => onLogin()}>Login</button>
                        }
                        
                    </div>

                    
                    {   new_account ?
                        <p className="login_body_terms">By sign-in you agree terms and conditions</p>
                    :
                        <div className="login_body_input_row ">
                            <button className="login_body_account_button" onClick={() => isAccount(true)}>Create your Account</button> 
                        </div>
                    }
                        
                    
                </div>


            </div>
        </div>
    )
}


export default Login;